export default __webpack_public_path__ + "static/media/localtext.05bb3ec6.csv";